import { render, staticRenderFns } from "./BoardListNoticeLayout.vue?vue&type=template&id=fe52a1ba&scoped=true"
import script from "./BoardListNoticeLayout.vue?vue&type=script&lang=js"
export * from "./BoardListNoticeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe52a1ba",
  null
  
)

export default component.exports